<template>
  <div class="root">
    <div class="searchDiv">
      <div class="searchmodel">
        <el-input
          v-model="keyword"
          @keyup.enter.native="changeBg('')"
          placeholder="请输入关键字搜索">
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="changeBg('')"></i>
        </el-input>
      </div>
    </div>
    <ul class="ul_left">
      <li v-for="(item, index) in li_bg" :key="index" @click="changeBg(index)">
        <img :src="index == idx ? item.on : item.off" alt />
      </li>
    </ul>
    <ul class="ul_right">
      <li class="li_right" v-for="(item, index) in list" :key="index">
        <router-link
          :to="{ name: '新闻中心详情', query: { id: item.id } }"
          v-show="idx == 0"
          >{{ item.title }}</router-link
        >
        <router-link
          :to="{ name: '成交公告详情', query: { id: item.id } }"
          v-show="idx == 1"
          >{{ item.projectAddress }}{{ item.projectName }}</router-link
        >
        <router-link
          :to="{ name: '鉴证书详情', query: { id: item.id } }"
          v-show="idx == 2"
          >{{ item.position }}{{ item.projectName }}</router-link
        >

        <router-link
          :to="{ name: '意向转出受让详情', query: { id: item.id } }"
          v-show="idx == 3 || idx == 4"
          >{{ item.projectname }}</router-link
        >

        <p>
          <span class="time" v-show="idx == 0 || idx == 3 || idx == 4">{{
            item.logintime
          }}</span>
          <span class="time" v-show="idx == 1">{{ item.dealtime }}</span>
          <span class="time" v-show="idx == 2">{{ item.updateTime }}</span>
          <span v-show="idx == 0">来源：{{ item.source }}</span>
        </p>
      </li>
    </ul>

    <div v-if="list.length > 0">
      <el-pagination
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        layout="prev, pager, next, jumper"
        :total="total"></el-pagination>
    </div>
    <h3 v-else style="font-size: 24px">暂无数据</h3>
  </div>
</template>

<script>
import { getNewslist, publicityList, attest, desiredList } from '../api/mian.js'
export default {
  data() {
    return {
      idx: 0,
      li_bg: [
        {
          on: require('../assets/img/通知公告1.png'),
          off: require('../assets/img/通知公告0.png'),
        },
        // {
        //   on: require("../assets/img/抵押公告1.png"),
        //   off: require("../assets/img/抵押公告0.png"),
        // },
        {
          on: require('../assets/img/成交公告1.png'),
          off: require('../assets/img/成交公告0.png'),
        },
        {
          on: require('../assets/img/鉴定公告1.png'),
          off: require('../assets/img/鉴定公告0.png'),
        },
        {
          on: require('../assets/img/意向转出1.png'),
          off: require('../assets/img/意向转出0.png'),
        },
        {
          on: require('../assets/img/意向受让1.png'),
          off: require('../assets/img/意向受让0.png'),
        },
      ],
      list: [],
      //   每页数据条数
      pagesize: 10,
      currentpage: 1,
      inputpage: 1,
      total: 0,
      keyword: '',
      listType: '',
    }
  },
  created() {
    // 重置idx
    this.idx = this.$route.query.type ? this.$route.query.type : 0

    this.listType = this.idx
    this.changeBg(this.idx)
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    changeBg(i = '') {
      console.log('i', i)
      this.listType = i === '' ? this.listType : i
      console.log(this.listType)
      this.$router.push({ name: '通知抵押公告', query: { type: i } })
      this.idx = this.listType
      i = this.idx
      if (i == 0) {
        // 通知公告数据
        let obj = {
          number: '004',
          pageNum: this.currentpage,
          pageSize: this.pagesize,
          keyword: this.keyword,
          searchValue: this.keyword,
        }
        getNewslist(obj).then((res) => {
          this.list = res.data.rows
          this.total = res.data.total
        })
      } else if (i == 1) {
        // 成交公告数据
        let obj = {
          number: '004',
          pageNum: this.currentpage,
          pageSize: this.pagesize,
          keyword: this.keyword,
          searchValue: this.keyword,
        }
        publicityList(obj).then((res) => {
          this.list = res.data.rows
          this.total = res.data.total
        })
      } else if (i == 2) {
        // 鉴证公告数据
        let obj = {
          pageNum: this.currentpage,
          pageSize: this.pagesize,
          keyword: this.keyword,
          searchValue: this.keyword,
        }
        attest(obj).then((res) => {
          this.list = res.data.rows
          this.total = res.data.total
        })
      } else if (i == 3) {
        // 意向转出数据
        let obj = {
          type: 1,
          pageNum: this.currentpage,
          pageSize: this.pagesize,
          keyword: this.keyword,
          searchValue: this.keyword,
        }
        desiredList(obj).then((res) => {
          this.total = res.data.total
          this.list = res.data.rows
        })
      } else if (i == 4) {
        // 意向转出数据
        let obj = {
          type: 2,
          pageNum: this.currentpage,
          pageSize: this.pagesize,
          keyword: this.keyword,
          searchValue: this.keyword,
        }
        desiredList(obj).then((res) => {
          this.list = res.data.rows
          this.total = res.data.total
        })
      } else {
      }
    },
    // 当前每夜多少条
    handleSizeChange(size) {
      this.pagesize = size
      this.listType = this.idx
      this.changeBg(this.idx)
    },
    // 当前页数
    handleCurrentChange(currentpage) {
      this.currentpage = currentpage
      this.listType = this.idx
      this.changeBg(this.idx)
    },
  },
}
</script>

<style scoped>
.root {
  min-height: 1180px;
  margin: 0 auto;
  margin-bottom: 35px;
  width: 1860px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  opacity: 1;
  overflow: hidden;
}

.ul_left {
  display: block;
  width: 260px;
  height: auto;
  float: left;
  /* background-color: rebeccapurple; */
  padding: 40px 100px;
  list-style: inside none;
}

.ul_left > li {
  display: block;
  width: 260px;
  height: 92px;
  /* background-color: red; */
  margin-bottom: 10px;
  cursor: pointer;
}

.ul_right {
  display: block;
  width: 1300px;
  max-height: 1230px;
  overflow: hidden;
  list-style: inside none;
  margin-bottom: 40px;
}

.ul_right .li_right {
  display: block;
  width: 1300px;
  height: 122px;
  border-bottom: 1px dotted #bebebe;
}

.li_right > a {
  display: block;
  padding: 37px 0 19px 0;
  max-width: 1200px;
  height: 26px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 26px;
  color: #666666;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.li_right > p {
  display: block;
  width: auto;

  height: 21px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 21px;
  color: #999999;
}

.li_right > p > span {
  display: inline-block;
  width: auto;
}

.li_right > p > .time {
  display: inline-block;
  width: 250px;
}

.el-pagination {
  text-align: center;
}

.searchmodel /deep/.el-input {
  font-size: 22px;
  /* border: 1px solid red; */
  text-align: left;
}

.searchmodel /deep/.el-input__inner {
  height: 50px;
  width: 300px;
  border: 1px solid #747474;
  border-radius: 10px;
  /* font-size: 16px; */
}

.searchmodel {
  /* margin-left: 500px; */
  width: 300px;
  padding: 0 30px;
  margin-top: 10px;
}
</style>
